import { render, staticRenderFns } from "./DriverDetails.vue?vue&type=template&id=006b11d0&scoped=true"
import script from "./DriverDetails.vue?vue&type=script&lang=js"
export * from "./DriverDetails.vue?vue&type=script&lang=js"
import style0 from "./DriverDetails.vue?vue&type=style&index=0&id=006b11d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b11d0",
  null
  
)

export default component.exports